import { EXPERIENCE_STATES, MENU_ITEMS } from "constants/experiences"

export const formatDuration = (tripLength, availableHours) => {
  if (tripLength === "full_day") return "Full day"
  if (tripLength === "half_day") return "Half day"
  return availableHours && availableHours.length > 0
    ? `${availableHours[0].start} - ${availableHours[0].end}`
    : "Varies"
}

export const formatTimeDuration = (minutes) => {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hrs && mins) return `${hrs}h ${mins}m`;
  if (hrs) return `${hrs}h`;
  if (mins) return `${mins}m`;
  return "0m";
};

export const getActionConditions = (status) => {
  switch (status) {
    case EXPERIENCE_STATES.published:
      return {
        [MENU_ITEMS.EDIT_CATEGORY]: true,
        [MENU_ITEMS.SHARE]: true,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: true,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: false
      }
    case EXPERIENCE_STATES.draft:
      return {
         [MENU_ITEMS.EDIT_CATEGORY]: true,
        [MENU_ITEMS.SHARE]: false,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: false,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: false
      }
    case EXPERIENCE_STATES.deactivated:
      return {
         [MENU_ITEMS.EDIT_CATEGORY]: true,
        [MENU_ITEMS.SHARE]: false,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: false,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: true
      }
    default:
      return {
         [MENU_ITEMS.EDIT_CATEGORY]: true,
         [MENU_ITEMS.PUBLISH]: true,
        [MENU_ITEMS.SHARE]: true,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: true,
        [MENU_ITEMS.DELETE]: true,
      }
  }
}

export const getDropdownItems = (menuConfig, conditions) => {
  return Object.values(menuConfig)
    .map(item => ({
      ...item,
      icon: <item.icon />,
      condition: conditions[item.key]
    }))
    .filter(item => item.condition)
} 
